import { render, staticRenderFns } from "./ExchangePopup.vue?vue&type=template&id=6289b0fa&"
import script from "./ExchangePopup.vue?vue&type=script&lang=ts&"
export * from "./ExchangePopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports